import { Col, Row, Switch } from "antd";
import { FilterValue } from "antd/lib/table/interface";
import NiceModal from "@ebay/nice-modal-react";
import { UpdatePaymentSettingRequest } from "src/hooks/usePaymentSetting";
import { PaymentSettingForm } from "src/pages/paymentSetting/PaymentSettingForm";
import { PaymentSetting } from "src/types";
import { getColumnFilters } from "src/utils/table";
import { ColumnType, EditButton } from "src/components";

interface PaymentSettingColumnsTypes {
  paymentList?: PaymentSetting[];
  filteredInfo: Record<string, FilterValue | null>;
  handleUpdatePaymentSetting: (params: UpdatePaymentSettingRequest) => void;
}

export const PaymentSettingColumns = ({
  paymentList = [],
  filteredInfo,
  handleUpdatePaymentSetting,
}: PaymentSettingColumnsTypes): ColumnType<PaymentSetting>[] => [
  {
    key: "name",
    title: "ระบบชำระเงิน",
    dataIndex: "name",
    filters: getColumnFilters("name", paymentList as Record<string, any>[]),
    filteredValue: filteredInfo.name || null,
    filterSearch: true,
    onFilter: (value, record: PaymentSetting) => {
      return record?.name === value;
    },
  },
  {
    title: "เปิด/ปิด",
    dataIndex: "isActived",
    key: "isActived",
    filteredValue: filteredInfo.isActived || null,
    filters: [
      {
        text: "เปิดการใช้งาน",
        value: true,
      },
      {
        text: "ปิดการใช้งาน",
        value: false,
      },
    ],
    onFilter: (value, record: PaymentSetting) => record?.isActived === value,
    render: (isActived, record) => (
      <Switch
        checked={isActived === true}
        checkedChildren="เปิด"
        unCheckedChildren="ปิด"
        onChange={(checked: boolean) =>
          handleUpdatePaymentSetting({ ...record, isActived: checked ? true : false })
        }
      />
    ),
  },
  {
    key: "depositMin",
    title: "ขั้นต่ำในการเติมเงิน",
    dataIndex: "depositMin",
    filters: getColumnFilters("depositMin", paymentList as Record<string, any>[]),
    filteredValue: filteredInfo.depositMin || null,
    filterSearch: true,
    onFilter: (value, record: PaymentSetting) => record?.depositMin === value,
    render: (value, record) => {
      return (
        <Row align="middle" style={{ padding: 4 }}>
          <Col flex="1 1 90%">
            <span>{value}</span>
          </Col>
          <Col flex="1 1 20px" style={{ textAlign: "right" }}>
            <EditButton
              size="small"
              onClick={() => {
                NiceModal.show(PaymentSettingForm, {
                  item: record,
                  onSubmit: ({ depositMin }) => {
                    handleUpdatePaymentSetting({
                      uid: record.uid,
                      name: record.name,
                      type: record.type,
                      isActived: record.isActived,
                      isBankEnabled: record.isBankEnabled,
                      depositMin: depositMin,
                    });
                  },
                });
              }}
            />
          </Col>
        </Row>
      );
    },
  },
];
